import * as React from "react";

const InstitutionReportItem = function(props) {
  return (
    <tr>
      <td>{props.id}</td>
      <td>{props.name}</td>
    </tr>
  );
};
export default InstitutionReportItem;
